export const DateFormatter = {
  formatDate(date: Date) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric', weekday: 'long' };
    return new Date(date).toLocaleDateString('de-AT', options);
  },
  formatBirthDate(date: Date) {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(date).toLocaleDateString('de-AT', options);
  },
  formatShortDate(date: string) {
    const options = { day: '2-digit', month: '2-digit', weekday: 'short' };
    return new Date(date).toLocaleDateString('de-AT', options);
  },
  formatTime(date: Date) {
    const options = { hour: '2-digit', minute: '2-digit' };
    return new Date(date).toLocaleTimeString('de-AT', options);
  },
};
